import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { MultiCheckboxContainer, CheckboxRow } from './styled';
import Checkbox from './subcomponents/Checkbox';

const MultiCheckbox = React.forwardRef(props => {
  const [selecteds, setSelecteds] = useState([]);
  const { options = [], 'data-cy': dataCy, onChange } = props;
  const handleCheck = useCallback(
    e => {
      e.persist();
      if (e.target.checked) {
        setSelecteds([...selecteds, { label: e.target.name, value: `${e.target.checked}` }]);
        onChange && onChange([...selecteds, { label: e.target.name, value: `${e.target.checked}` }]);
      } else {
        const newState = selecteds.filter(item => `${item.label}` !== `${e.target.name}`);
        setSelecteds(newState);
        onChange && onChange(newState);
      }
    },
    [onChange, selecteds],
  );
  return (
    <MultiCheckboxContainer>
      {options.map((option, index) => (
        <CheckboxRow key={index}>
          <Checkbox
            key={index}
            label={option.label}
            data-cy={`${dataCy}-option`}
            onChange={handleCheck}
            name={option.label}
          />
        </CheckboxRow>
      ))}
    </MultiCheckboxContainer>
  );
});

MultiCheckbox.propTypes = {
  text: PropTypes.string,
};

export { MultiCheckbox };
